import script from "./VolunteeringOpen.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteeringOpen.vue?vue&type=script&setup=true&lang=js"

import "./VolunteeringOpen.vue?vue&type=style&index=0&id=362052e6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-362052e6"]])

export default __exports__